import React from "react";
import { Box, Drawer } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { colours } from "../constants/theme";

const sidenavWidth = 256;
const headerHeight = 64;

const useStyles = makeStyles(
  createStyles({
    navbar: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: headerHeight,
      zIndex: 1201,
      backgroundColor: colours.highEmphasis,
      display: "flex",
      alignItems: "center",
      paddingLeft: 24,
      paddingRight: 24,
      gap: 20,
    },
    drawerPaper: {
      width: sidenavWidth,
      paddingTop: headerHeight,
      backgroundColor: colours.highEmphasis,
    },
    content: {
      marginLeft: sidenavWidth,
      marginTop: headerHeight,
      padding: 48,
      flex: 1,
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
      padding: "12px 20px",
      gap: 16,
    },
    dashboardGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 16,
      marginBottom: 24,
    },
  }),
);

export function NavbarAndDashboardSkeleton() {
  const classes = useStyles();

  return (
    <>
      {/* Skeleton navbar */}
      <Box className={classes.navbar}>
        <Skeleton
          variant="rect"
          width={180}
          height={44}
          style={{ borderRadius: 4, backgroundColor: "rgba(255,255,255,0.12)" }}
        />
        <Skeleton
          variant="rect"
          width={1}
          height={44}
          style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
        />
        <Skeleton
          variant="text"
          width={160}
          height={36}
          style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
        />
        <Box flex={1} />
        <Skeleton
          variant="circle"
          width={48}
          height={48}
          style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
        />
      </Box>

      {/* Skeleton sidenav */}
      <Drawer variant="permanent" classes={{ paper: classes.drawerPaper }}>
        {Array.from({ length: 11 }).map((_, i) => (
          <Box key={i} className={classes.menuItem}>
            <Skeleton
              variant="circle"
              width={28}
              height={28}
              style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
            />
            <Skeleton
              variant="text"
              width={150}
              height={24}
              style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
            />
          </Box>
        ))}
      </Drawer>

      {/* Skeleton dashboard content */}
      <Box className={classes.content}>
        <Skeleton
          variant="text"
          width={200}
          height={36}
          style={{ marginBottom: 16 }}
        />

        <Box className={classes.dashboardGrid}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton
              key={i}
              variant="rect"
              height={140}
              style={{ borderRadius: 8 }}
            />
          ))}
        </Box>
      </Box>
    </>
  );
}
